<template>
  <div class="login-signin">
    <div class="mb-0">
      <h3 class="opacity-40 font-weight-normal">Sign In</h3>
<!--      <p class="opacity-40">Enter your details to login to your account:</p>-->
    </div>
    <b-form class="form" id="kt_login_signin_form" @submit.stop.prevent="onSubmit">
      <div
          role="alert"
          v-bind:class="{ show: errors && errors.length }"
          class="alert fade alert-danger"
      >
        <div class="alert-text" v-for="(error, i) in errors" :key="i">
          {{ error.message }}
        </div>
      </div>
      <b-input-group
          class="mb-5"
          id="example-input-group-1"
          label=""
          label-for="example-input-1"
      >
        <b-form-input
            class="form-control h-auto text-white bg-white-o-5 rounded-pill border-0 py-4 px-8"
            id="example-input-1"
            name="example-input-1"
            placeholder="Email"
            v-model="$v.form.email.$model"
            :state="validateState('email')"
            aria-describedby="input-1-live-feedback"
        ></b-form-input>

        <b-form-invalid-feedback style="text-align: left" id="input-1-live-feedback">
          Email is required and a valid email address.
        </b-form-invalid-feedback>
      </b-input-group>

      <b-input-group
          class="mb-5"
          id="example-input-group-2"
          label=""
          label-for="example-input-2"
      >
        <b-form-input
            class="form-control h-auto text-white bg-white-o-5 rounded-pill border-0 py-4 px-8"
            :type="show ? 'text' : 'password'"
            id="example-input-2"
            name="example-input-2"
            placeholder="Access token"
            v-model="$v.form.token.$model"
            :state="validateState('token')"
            aria-describedby="input-2-live-feedback"
        ></b-form-input>

        <b-form-invalid-feedback style="text-align: left" id="input-2-live-feedback">
          Access token is required (min 8 characters).
        </b-form-invalid-feedback>
      </b-input-group>

      <div class="form-group d-flex flex-wrap justify-content-between align-items-center px-1 opacity-60">
        <div class="checkbox-inline">
          <!--                  <label class="checkbox checkbox-outline checkbox-white text-white m-0">-->
          <!--                    <input type="checkbox" name="remember" />-->
          <!--                    <span></span>Remember me</label>-->
        </div>
      </div>
      <div class="form-group text-center mt-5">
        <button ref="kt_login_signin_submit" class="btn btn-pill btn-primary opacity-90 px-15 py-3">Sign In</button>
      </div>
    </b-form>
    <!--	<div class="mt-10">
        <span class="opacity-40 mr-4">Don't have an account yet?</span>
        <a href="javascript:;" id="kt_login_signup" class="text-white opacity-30 font-weight-normal">Sign Up</a>
      </div> -->
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import {mapState} from "vuex";
import {LOGIN, CLEAR_AUTH_ERRORS, GHOST_LOGIN} from "@/core/services/store/auth.module";

import {validationMixin} from "vuelidate";
import {email, minLength, required} from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "ghost-login",
  data() {
    return {
      show: false,
      // Remove this dummy login info
      form: {
        email: "",
        token: ""
      }
    };
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      token: {
        required,
        minLength: minLength(8)
      }
    }
  },
  methods: {
    validateState(name) {
      const {$dirty, $error} = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        email: null,
        token: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const email = this.$v.form.email.$model;
      const token = this.$v.form.token.$model;

      // clear existing errors
      this.$store.dispatch(CLEAR_AUTH_ERRORS);

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      submitButton.disabled = true;

      // send login request
      this.$store
          .dispatch(GHOST_LOGIN, {email, token, access_token: token})
          // go to which page after successfully login
          .then((data) => {
            if (data._metadata.outcomeCode === 0) {
              submitButton.classList.remove(
                  "spinner",
                  "spinner-light",
                  "spinner-right"
              );
              this.$router.push({path: '/'});
              submitButton.disabled = false;
            } else {
              submitButton.classList.remove(
                  "spinner",
                  "spinner-light",
                  "spinner-right"
              );
              submitButton.disabled = false;
            }
          });
    },
    getLogo() {
      return process.env.BASE_URL + "media/logos/logo.jpg";
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    })
  }
};
</script>
